<template>
  <div class="d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="空置房管理" name="emptyRoom">
          <EmptyRoomList v-if="activeName === 'emptyRoom'" />
        </el-tab-pane>
        <el-tab-pane label="开发商管理" name="developerUser">
          <DeveloperUser v-if="activeName === 'developerUser'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ErpTree from "../Common/erp-tree";
import ErpTreeStatus from "../Common/erp-tree-status";
import EmptyRoomList from "./components/room-status/EmptyRoomList";
import DeveloperUser from "./components/room-status/DeveloperUser";

export default {
  name: "EmptyRoom",
  components: {
    DeveloperUser,
    EmptyRoomList,
    ErpTreeStatus,
    ErpTree
  },
  provide() {
    return {
      mainObj: this.mainObj,
    };
  },
  data(){
    return{
      mainObj: {
        project_id:0,
        house_name:""
      },
      activeName: "emptyRoom",
    }
  },
  methods: {
    nodeClick(node){
      this.mainObj.house_name=node.tree.map(ret => {
        return ret.name
      }).join('->');
      this.mainObj.project_id=node.tree[0].id;
    }
  }
}
</script>

<style lang="scss" scoped>

.d-flex {
  display: flex;
  margin: 10px;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/EmptyRoom.vue